/**
 * auth-js 2.86–2.110 deletes the PKCE code verifier inside session save and
 * session removal. Google sign-in often still has a Supabase session in
 * storage, so the callback's session refresh wipes the verifier and the first
 * exchange fails. The next attempt works because that session is already gone.
 *
 * Ignore those deletes. The verifier is overwritten when a new flow starts,
 * and cleared explicitly after a successful exchange.
 */

const FLOW_INDEX_SUFFIX = "-flows-code-verifier";
const VERIFIER_SUFFIX = "-code-verifier";

export function isPkceVerifierStorageKey(key) {
  return (
    typeof key === "string" &&
    key.endsWith(VERIFIER_SUFFIX) &&
    !key.endsWith(FLOW_INDEX_SUFFIX)
  );
}

export function createPkceVerifierGuardingStorage(backing) {
  return {
    getItem(key) {
      return backing.getItem(key);
    },
    setItem(key, value) {
      return backing.setItem(key, value);
    },
    removeItem(key) {
      if (isPkceVerifierStorageKey(key)) {
        return;
      }
      return backing.removeItem(key);
    },
  };
}

/** Remove verifier slots from the raw storage, bypassing the guard. */
export function clearPkceVerifiers(storage) {
  if (!storage || typeof storage.length !== "number" || typeof storage.key !== "function") {
    return;
  }
  const keys = [];
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (isPkceVerifierStorageKey(key)) {
      keys.push(key);
    }
  }
  keys.forEach((key) => storage.removeItem(key));
}
